export const isRequiredBasedOn = (currentCompanyLegalStatus: string) => currentCompanyLegalStatus === 'Partnership' || currentCompanyLegalStatus === 'Sole trader';
